<template>
  <a-locale-provider :locale="locale">
    <div class="order-search-container">
      <div class="order-search-tab">
        <a-tabs
          defaultActiveKey="1"
          v-model="activeTabKey"
        >
          <!--简单查询-->
          <a-tab-pane tab="订单记录" key="1">
            <a-form class="order-search-form" :form="simpleForm" :layout="formLayout">
              <a-row>
                <a-col :xs="24" :xl="12">
                  <a-form-item
                    label="值机日期"
                  >
                    <a-date-picker
                      class="form-input-xl-fix"
                      placeholder="选择日期"
                      v-model="orderStartDate"
                      :disabledDate="startDisabledDate"
                      :showToday="false"
                      @change="onChange" />
                  </a-form-item>
                  <div class="form-split">至</div>
                  <a-form-item>
                    <a-date-picker
                      class="form-input-xl-fix"
                      placeholder="选择日期"
                      v-model="orderEndDate"
                      :disabledDate="endDisabledDate"
                      :showToday="false"
                      @change="onChange" />
                  </a-form-item>
                </a-col>
                <a-col :xs="24" :xl="12">
                  <a-form-item>
                    <a-button class="order-primary-btn"
                      type="primary"
                      :loading="orderLoading"
                      @click="simpleFormSubmitHandler"
                    >
                      查询
                    </a-button>
                  </a-form-item>
                </a-col>
              </a-row>
            </a-form>
          </a-tab-pane>
          <!--精准查询-->
          <a-tab-pane tab="精准查询" key="2">
            <a-form class="order-search-form" :form="fullForm" :layout="formLayout">
              <a-row>
                <a-col :xs="24" :xl="fullTabLCol">
                  <a-form-item
                    label="值机单号"
                  >
                    <a-input
                      v-model="seatOrderNo"
                    ></a-input>
                  </a-form-item>
                </a-col>
                <a-col :xs="24" :xl="fullTabRCol">
                  <a-form-item
                    label="值机日期"
                  >
                    <a-date-picker
                      placeholder="选择日期"
                      v-model="orderStartDate"
                      :disabledDate="startDisabledDate"
                      :showToday="false"
                    />
                  </a-form-item>
                  <div class="form-split">至</div>
                  <a-form-item>
                    <a-date-picker
                      placeholder="选择日期"
                      v-model="orderEndDate"
                      :disabledDate="endDisabledDate"
                      :showToday="false"
                    />
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row>
                <a-col :xs="24" :xl="fullTabLCol">
                  <a-form-item
                    label="旅客姓名"
                  >
                    <a-input
                      v-model="passengerChnName"
                    ></a-input>
                  </a-form-item>
                </a-col>
                <a-col :xs="24" :xl="fullTabRCol">
                  <a-form-item
                    label="航班日期"
                  >
                    <a-date-picker
                      placeholder="开始时间"
                      v-model="segStartDate"
                      :disabledDate="startSegDisabledDate"
                      :showToday="false"
                    />
                  </a-form-item>
                  <div class="form-split">至</div>
                  <a-form-item>
                    <a-date-picker
                      placeholder="结束时间"
                      v-model="segEndDate"
                      :disabledDate="endSegDisabledDate"
                      :showToday="false"
                    />
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row>
                <a-col :xs="24" :xl="fullTabLCol">
                  <a-form-item
                    label="航班号"
                  >
                    <a-input
                      v-model="flightNo"
                    ></a-input>
                  </a-form-item>
                </a-col>
                <a-col :xs="24" :xl="fullTabLCol" class="form-item-ticket">
                  <a-form-item
                    label="票号"
                  >
                    <a-input
                      class="input-ticket-prefix"
                      v-decorator="[
                      'issCode',
                          {
                          rules: [
                            { validator: handleFieldValidate }
                          ],
                          validateTrigger: 'blur',
                          initialValue: '859'
                        }
                      ]"
                    />
                  </a-form-item>
                  <div class="form-split split-ticket">-</div>
                  <a-form-item>
                    <a-input
                      class="input-ticket"
                      v-decorator="[
                      'ticketNo',
                          {
                          rules: [
                            { validator: handleFieldValidate }
                          ],
                          validateTrigger: 'blur'
                        }
                      ]"
                    />
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row>
                <a-col :xs="24" :xl="fullTabLCol">
                  <a-form-item
                    label="证件类型"
                  >
                    <a-select v-model="cerType" defaultValue="">
                      <a-select-option value="">全部</a-select-option>
                      <a-select-option value="NI">身份证</a-select-option>
                      <a-select-option value="PP">护照</a-select-option>
                      <a-select-option value="TN">电子客票号</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :xs="24" :xl="fullTabRCol">
                  <a-form-item
                    label="航段"
                  >
                    <l8-flightcityselector
                      v-model="depCity"
                      placeholder="出发城市"
                    ></l8-flightcityselector>
                  </a-form-item>
                  <div class="form-split">至</div>
                  <a-form-item>
                    <l8-flightcityselector
                      v-model="arrCity"
                      placeholder="到达城市"
                    ></l8-flightcityselector>
                  </a-form-item>
                </a-col>

              </a-row>
              <a-row>
                <a-col :xs="24" :xl="fullTabLCol">
                  <a-form-item
                    label="证件号"
                  >
                    <a-input
                      v-model="certId"
                    ></a-input>
                  </a-form-item>
                </a-col>
                <a-col :xs="24" :xl="fullTabRCol">
                  <a-form-item>
                    <a-button
                      class="order-primary-btn"
                      type="primary"
                      :loading="orderLoading"
                      @click="fullFormSubmitHandler"
                    >
                      查询
                    </a-button>
                  </a-form-item>
                </a-col>
              </a-row>
            </a-form>
          </a-tab-pane>
        </a-tabs>
      </div>
      <div class="order-search-table">
        <a-table class="order-table"
                 :dataSource='orderListData'
                 :columns='orderListCols'
                 :pagination="orderPagination"
                 :loading="orderLoading"
                 @change="orderListChangeHandler"
        >
          <router-link class="l8-href" slot="seatOrderNo" slot-scope="seatOrderNo, record" :to="'/checkin/detail?seatOrderId=' + record.id">{{ seatOrderNo }}</router-link>
        </a-table>
      </div>
    </div>
  </a-locale-provider>
</template>

<script>
import { queryCheckinList } from '@/apis/checkin'
import '@/components/l8-icon'
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
import { validate } from '@/assets/js/validate'
import moment from 'moment'
import { map } from 'lodash'
import './index'

const orderListCols = [
  {
    title: '序号',
    dataIndex: 'key',
    key: 'key'
  },
  {
    title: '值机单号',
    dataIndex: 'seatOrderNo',
    key: 'seatOrderNo',
    scopedSlots: { customRender: 'seatOrderNo' }
  },
  {
    title: '订票时间',
    dataIndex: 'createTime',
    key: 'createTime'
  },
  {
    title: '航班号',
    dataIndex: 'flightNo',
    key: 'flightNo'
  },
  {
    title: '乘客姓名',
    dataIndex: 'passengerChnName',
    key: 'passengerChnName'
  },
  {
    title: '航班日期',
    dataIndex: 'flightDate',
    key: 'flightDate'
  },
  {
    title: '座位号',
    dataIndex: 'seatNumber',
    key: 'seatNumber'
  },
  {
    title: '舱位',
    dataIndex: 'seatClass',
    key: 'seatClass'
  },
  {
    title: '出发城市',
    dataIndex: 'depName',
    key: 'depName'
  },
  {
    title: '到达城市',
    dataIndex: 'arrName',
    key: 'arrName'
  },
  {
    title: '飞机型号',
    dataIndex: 'airplaneType',
    key: 'airplaneType'
  }
]

export default {
  data () {
    return {
      locale: zhCN,
      fullTabLCol: 9,
      fullTabRCol: 15,
      activeTabKey: '1',
      formLayout: 'inline',
      formItemLayout: {
        labelCol: { span: 6 },
        wrapperCol: { span: 18 }
      },
      simpleForm: this.$form.createForm(this),
      fullForm: this.$form.createForm(this),
      orderListData: [],
      orderListCols: orderListCols,
      orderPagination: {
        defaultCurrent: 1,
        defaultPageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showSizeChanger: true,
        showQuickJumper: true,
        total: 10
      },
      orderLoading: true,
      // 查询参数
      page: 1,
      pageSize: 10,
      orderStartDate: null,
      orderEndDate: null,
      issCode: 859,
      depCity: '',
      arrCity: '',
      cerType: '',
      certId: '',
      flightNo: '',
      segEndDate: null,
      segStartDate: null,
      ticketNo: '',
      seatOrderNo: '',
      passengerChnName: ''
    }
  },
  mounted () {
    const that = this
    window.onresize = () => {
      return (() => {
        let width = window.innerWidth
        if (width < 992) {
          that.formLayout = 'horizontal'
        } else {
          that.formLayout = 'inline'
        }
      })()
    }
  },
  created () {
    let width = window.outerWidth
    if (width < 992) {
      this.formLayout = 'horizontal'
    }

    this.fetchOrderList()
  },
  computed: {
    queryStartDate () {
      if (this.orderStartDate) {
        return this.orderStartDate.format('YYYY-MM-DD')
      } else {
        return ''
      }
    },
    queryEndDate () {
      if (this.orderEndDate) {
        return this.orderEndDate.format('YYYY-MM-DD')
      } else {
        return ''
      }
    },
    queryParams () {
      let params
      if (this.activeTabKey === '1') {
        params = {
          'createTimeStart': this.queryStartDate,
          'createTimeEnd': this.queryEndDate,
          'page': this.page,
          'pageSize': this.pageSize
        }
      } else {
        params = {
          'createTimeStart': this.queryStartDate,
          'createTimeEnd': this.queryEndDate,
          'issCode': this.issCode || 859,
          'orgCity': this.depCity || '',
          'dstCity': this.arrCity || '',
          'idType': this.cerType || '',
          'flightNo': this.flightNo || '',
          'flightEndDate': this.segEndDate || '',
          'flightStartDate': this.segStartDate || '',
          'ticketNo': this.ticketNo || '',
          'certId': this.certId || '',
          'passengerChnName': this.passengerChnName || '',
          'seatOrderNo': this.seatOrderNo || '',
          'page': this.page,
          'pageSize': this.pageSize
        }
      }

      return params
    }
  },
  methods: {
    startDisabledDate (current) {
      return current && current > moment().endOf('day')
    },
    endDisabledDate (current) {
      if (this.orderStartDate) {
        return current && (current < this.orderStartDate.startOf('day') || current > moment().endOf('day'))
      } else {
        return current && current > moment().endOf('day')
      }
    },
    startSegDisabledDate (current) {
      if (this.segEndDate) {
        return current && (current > this.segEndDate.endOf('day'))
      } else {
        return false
      }
    },
    endSegDisabledDate (current) {
      if (this.segStartDate) {
        return current && (current < this.segStartDate.startOf('day'))
      } else {
        return false
      }
    },
    handleFieldValidate (rule, value, callback) {
      const formValues = this.fullForm.getFieldsValue()
      validate('ordersearch', formValues, rule.fullField).then(({ valid, errors }) => {
        if (valid) {
          callback && callback()
        } else {
          callback(errors[0].message)
        }
      })
    },
    orderListChangeHandler (pagination) {
      this.page = pagination.current
      this.pageSize = pagination.pageSize

      this.fetchOrderList()
    },
    simpleFormSubmitHandler () {
      this.page = 1
      this.fetchOrderList()
    },
    fullFormSubmitHandler () {
      this.fullForm.validateFieldsAndScroll((errors, values) => {
        if (!errors) {
          this.issCode = values.issCode
          this.ticketNo = values.ticketNo
          this.page = 1
          this.fetchOrderList()
        }
      })
    },
    async fetchOrderList () {
      this.orderLoading = true

      try {
        const res = await queryCheckinList(this.queryParams)

        this.orderLoading = false

        this.updateOrderList(res.list)
        this.$set(this.orderPagination, 'current', res.currentPageNumber)
        this.$set(this.orderPagination, 'total', res.totalResultCount)
      } catch (err) {
        this.orderLoading = false
        this.$message.error(err.message || '订单查询失败，请稍后再试')
      }
    },
    updateOrderList (orderList) {
      let orderData = map(orderList, (order, index) => {
        let item = {
          key: index + 1,
          id: order.id,
          seatOrderNo: order.seatOrderNo,
          createTime: moment(order.createTime).format('YYYY-MM-DD HH:mm:ss'),
          flightNo: order.flightNo,
          passengerChnName: order.passengerChnName,
          flightDate: order.flightDate,
          seatNumber: order.seatNumber,
          seatClass: order.seatClass,
          depName: order.depName,
          arrName: order.arrName,
          airplaneType: order.airplaneType
        }

        return item
      })

      this.orderListData = orderData
    }
  }
}
</script>

<style lang="less">
  .order-search-container {
    padding: 20px;
    position: relative;
  }

  .ant-btn.order-primary-btn {
    width: 100px;
    height: 42px;
  }

  /*查询表单样式*/
  .order-search-form {

    &.ant-form-inline {
      .ant-form-item {
        &.ant-row {
          margin-bottom: 16px;
        }
      }

      .ant-form-item-label label {
        color: #333;
        width: 90px;
        display: inline-block;
      }
    }

    .input-ticket-prefix {
      width: 50px;
    }

    .input-ticket {
      width: 94px;
    }

    .ant-input {
      height: 48px;
    }

    .ant-form-explain {
      margin-top: 0;
    }

    .form-item-ticket {
      .ant-form-explain {
        margin-right: -60px;
      }
    }

    .ant-select,
    .ant-cascader-picker {
      width: 182px;
      display: inline-block;
    }

    .ant-select-selection--single {
     height: 48px;
    }

    .ant-select-selection__rendered {
      line-height: 48px;
    }

    .form-split {
      display: inline-block;
      margin-right: 16px;
      line-height: 51.999px;
    }
  }

  /*订单列表*/
  .order-table {

    .ant-table-thead > tr > th,
    .ant-table-tbody > tr > td {
      padding: 14px 5px;
    }

    table {
      td {
        vertical-align: middle;
      }
    }

    .l8-href {
      text-decoration: underline;
    }
  }

  /*订单列表导出*/
  .order-ext {
    position: absolute;
    bottom: 30px;
    left: 20px;
    z-index: 1;
  }

  .order-ext-btn {
    display: inline-block;
    width: 32px;
    height: 32px;
    margin-left: 10px;
  }

  @media only screen and (max-width: 992px) {
    .order-search-form   {
      .ant-form-item {
        &.ant-row {
          margin-bottom: 6px;
        }
      }

      .input-ticket-prefix {
        width: 100%;
      }

      .input-ticket {
        width: 100%;
      }

      .ant-form-item-label {
        margin-bottom: 5px;
      }

      .ant-calendar-picker {
        width: 100%;
      }

      .ant-select,
      .ant-cascader-picker {
        width: 100%;
        display: inline-block;
      }

      .form-split {
        display: block;
        line-height: 30px;
      }
    }

    .order-table {
      table {
        td {
          vertical-align: middle;
          min-width: 120px;
        }
      }

      .ant-table {
        overflow-x: scroll;
        word-break: keep-all;
      }
    }

    .ant-btn.order-primary-btn {
      width: 100%;
    }
  }

  @media (min-width: 1200px) and (max-width: 1300px) {
    .order-search-form   {
      .form-input-xl-fix {
        .ant-input {
          width: 120px;
        }
      }
    }
  }
</style>
